import React from "react";
import { Box, Typography } from "@material-ui/core";
import LocalHelmet from "./Helmet";
import { useIntl } from "react-intl";

interface IProps {
  type: "privacy" | "cookies";
}

const privacySections = [
  {
    title: "Pārzinis un kontaktinformācija",
    body: "Personas datu pārzinis ir SIA Baltic Project Group. Ar jautājumiem par personas datu apstrādi var sazināties, rakstot uz retro@bpgroup.lv vai izmantojot vietnes sadaļu Kontakti.",
  },
  {
    title: "Kādus datus apstrādājam",
    body: "Mēs apstrādājam klienta vārdu, uzvārdu, uzņēmuma informāciju, e-pastu, tālruņa numuru, piegādes un norēķinu adresi, pasūtījumu vēsturi, groza saturu un tehniskos vietnes lietošanas datus.",
  },
  {
    title: "Apstrādes nolūki",
    body: "Dati tiek izmantoti reģistrācijai, pasūtījumu noformēšanai un izpildei, klientu atbalstam, rēķinu sagatavošanai, piegādes organizēšanai, drošības nodrošināšanai un normatīvo aktu prasību izpildei.",
  },
  {
    title: "Tiesiskais pamats",
    body: "Datu apstrāde notiek līguma sagatavošanai un izpildei, juridisko pienākumu izpildei, leģitīmajām interesēm nodrošināt vietnes darbību un klientu apkalpošanu, kā arī pēc piekrišanas, ja tā ir nepieciešama mārketingam vai sīkdatnēm.",
  },
  {
    title: "Datu saņēmēji",
    body: "Dati var tikt nodoti IT uzturētājiem, maksājumu un piegādes pakalpojumu sniedzējiem, grāmatvedības pakalpojumu sniedzējiem un valsts iestādēm, ja to paredz normatīvie akti.",
  },
  {
    title: "Glabāšanas termiņi",
    body: "Dati tiek glabāti tik ilgi, cik nepieciešams attiecīgajam nolūkam, līguma saistību izpildei, grāmatvedības prasībām vai strīdu risināšanai. Pēc termiņa beigām dati tiek dzēsti vai anonimizēti.",
  },
  {
    title: "Jūsu tiesības",
    body: "Jums ir tiesības pieprasīt piekļuvi saviem datiem, to labošanu, dzēšanu, apstrādes ierobežošanu, datu pārnesamību un iebilst pret apstrādi. Jums ir tiesības iesniegt sūdzību Datu valsts inspekcijā.",
  },
];

const cookieSections = [
  {
    title: "Kas ir sīkdatnes",
    body: "Sīkdatnes ir nelieli teksta faili, kas tiek saglabāti ierīcē, lai vietne varētu darboties, atcerēties lietotāja izvēles un uzlabot pakalpojuma kvalitāti.",
  },
  {
    title: "Nepieciešamās sīkdatnes",
    body: "Nepieciešamās sīkdatnes nodrošina sesiju, groza darbību, drošību un valodas izvēles saglabāšanu. Bez tām vietne nevar pilnvērtīgi darboties.",
  },
  {
    title: "Analītikas sīkdatnes",
    body: "Ar piekrišanu var tikt izmantotas analītikas sīkdatnes, lai saprastu vietnes lietojumu, ielādes ātrumu un populārākās sadaļas. Šie dati palīdz uzlabot vietnes darbību.",
  },
  {
    title: "Piekrišanas pārvaldība",
    body: "Sīkdatņu izvēli var mainīt pārlūkprogrammas iestatījumos. Ja pārlūkprogrammā sīkdatnes tiek dzēstas, vietne var vēlreiz lūgt apstiprināt izvēli.",
  },
  {
    title: "Trešo pušu rīki",
    body: "Vietnē var tikt izmantoti trešo pušu rīki, piemēram, analītikai vai drošībai. Šie pakalpojumu sniedzēji apstrādā datus saskaņā ar saviem noteikumiem un piemērojamiem tiesību aktiem.",
  },
];

const LegalPage: React.FC<IProps> = ({ type }) => {
  const intl = useIntl();
  const titleId = type === "privacy" ? "personData.title" : "consent.title";
  const title = intl.formatMessage({ id: titleId });
  const sections = type === "privacy" ? privacySections : cookieSections;

  return (
    <Box p={3}>
      <LocalHelmet title={title} description={sections[0].body} />
      <Typography component="h1" variant="h4" gutterBottom>
        {title}
      </Typography>
      {sections.map((section) => (
        <Box key={section.title} pb={2}>
          <Typography component="h2" variant="h6" gutterBottom>
            {section.title}
          </Typography>
          <Typography paragraph>
            {section.body}
          </Typography>
        </Box>
      ))}
      <Typography paragraph>
        Pēdējās izmaiņas: 2026. gada 7. septembris.
      </Typography>
    </Box>
  );
};

export default LegalPage;
